import { useWebSettings } from "@/models/StateProviders/WebSettingsProvider";

/**
 * Whether the Dispatch task surface is on: the workspace's `web.dispatch.tasks`.
 *
 * No browser-local override: the flag is the workspace's, and a member cannot set it.
 */
export function useTasksEnabled(): boolean {
  return useWebSettings().settings.dispatch.tasks;
}
